import { DependencyList, useCallback, useEffect, useRef } from "react"
import { AppState } from "react-native"

export const useComeForeground = (callBack: () => void, deps: DependencyList) => {
  const appState = useRef(AppState.currentState)

  const callBackWrapper = useCallback(callBack, [callBack, ...deps])

  useEffect(() => {
    const subscription = AppState.addEventListener("change", (nextAppState) => {
      if (appState.current.match(/inactive|background/) && nextAppState === "active") {
        callBackWrapper()
      }
      appState.current = nextAppState
    })

    return () => {
      subscription.remove()
    }
  }, [callBackWrapper])
}
